import {submitHandler} from '../submit-handler';
import {UserFormValuesExtractor} from './userFormValuesExtractor';
import {initActivityForm} from './activity';

const TERMS_VERSION = '2026-05-07';
const OFFER_VERSION = '2026-05-07';
const PRIVACY_VERSION = '2026-05-13';
const PD_GENERAL_VERSION = '2026-05-08';
const PD_SPECIAL_VERSION = '2026-05-08';

function postConsent(record) {
    return fetch('/consent', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(record),
        keepalive: true,
    }).catch((err) => {
        // Non-blocking: log and continue. Replace with proper telemetry once
        // the bod-core-api endpoint is wired in.
        console.error('[consent] failed to record', err);
    });
}

export function initRegister($, apiClient) {
    initActivityForm();
    const valuesExtractor = new UserFormValuesExtractor();

    const $termsCheckbox = $('form.register-form #accept-terms-checkbox');
    const $pdCheckbox = $('form.register-form #accept-pd-checkbox');
    const $submitButton = $('form.register-form .action__register');

    function updateSubmitState() {
        const termsAccepted = $termsCheckbox.is(':checked');
        const pdAccepted = $pdCheckbox.is(':checked');
        $submitButton.prop('disabled', !(termsAccepted && pdAccepted));
    }

    $('form.register-form input[name="sex"]').on('change', function () {
        $('form.register-form input[name="sex"]').closest('.floating-label-3').removeClass('field-missing');
    });

    $termsCheckbox.on('click', updateSubmitState);
    $pdCheckbox.on('click', updateSubmitState);
    updateSubmitState();

    submitHandler('form.register-form .action__register', async function () {
        const termsAccepted = $termsCheckbox.is(':checked');
        const pdAccepted = $pdCheckbox.is(':checked');
        if (!termsAccepted || !pdAccepted) return;

        // Пол обязателен и заранее не выбран. Проверяем здесь: сервер тоже
        // откажет, но подсветить ему нечего — у радиокнопок нет #sex.
        const $sex = $('form.register-form input[name="sex"]');
        $sex.closest('.floating-label-3').removeClass('field-missing');
        if (!$sex.filter(':checked').length) {
            $sex.closest('.floating-label-3').addClass('field-missing');
            $('.common-form-error').html('Выберите пол').show();
            throw { handled: true };
        }

        const user = valuesExtractor.extractUserRegistrationParams();
        await apiClient.createUser(user);

        // С этого момента учётная запись существует. Письмо со ссылкой для
        // входа — отдельный шаг, и его неудача не должна отменять остальное:
        // раньше человек видел «Что-то пошло не так», согласия не
        // записывались, а повторная регистрация упиралась в «почта уже
        // зарегистрирована». Теперь говорим честно и даём запросить письмо
        // ещё раз.
        let emailSent = true;
        try {
            await apiClient.restore({ email: user.email });
        } catch (e) {
            emailSent = false;
            console.error('[register] письмо для входа не отправилось', e);
        }

        // Record consents after successful registration. Fire-and-forget,
        // failures are logged but do not interrupt the user flow.
        const baseRecord = {
            email: user.email,
            acceptedAt: new Date().toISOString(),
            userAgent: navigator.userAgent,
        };
        postConsent({ ...baseRecord, documentType: 'offer', documentVersion: OFFER_VERSION, accepted: true });
        postConsent({ ...baseRecord, documentType: 'terms', documentVersion: TERMS_VERSION, accepted: true });
        postConsent({ ...baseRecord, documentType: 'privacy', documentVersion: PRIVACY_VERSION, accepted: true });
        postConsent({ ...baseRecord, documentType: 'pd_general', documentVersion: PD_GENERAL_VERSION, accepted: true });
        postConsent({ ...baseRecord, documentType: 'pd_special', documentVersion: PD_SPECIAL_VERSION, accepted: true });

        document.location.href = emailSent ? '/complete' : '/complete?email=failed';
    });
}
